// Global call state — persisted in localStorage so the floating
// CallBanner survives route changes. The banner listens to both the
// standard `storage` event (from other tabs) and a custom
// `caring-call-changed` event dispatched from this same tab.
//
// The backend remains the source of truth for KPIs (call_segments on
// the lead). This module is purely a UI convenience so the operator
// sees the timer wherever they navigate after "Sim, ligar".

const KEY = "caring_active_call";
const EVT = "caring-call-changed";

/** @typedef {{leadId:string, leadName?:string, phone?:string, startedAt:string}} ActiveCall */

/** Read current active call from localStorage. Returns null if none. */
export function getActiveCall() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch { return null; }
}

/** Persist an active call and notify listeners. */
export function setActiveCall(call) {
  if (!call || !call.leadId) return;
  const value = {
    leadId: call.leadId,
    leadName: call.leadName || "",
    phone: call.phone || "",
    startedAt: call.startedAt || new Date().toISOString(),
  };
  localStorage.setItem(KEY, JSON.stringify(value));
  window.dispatchEvent(new CustomEvent(EVT));
}

/** Clear the active call and notify listeners. */
export function clearActiveCall() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent(EVT));
}

/** Subscribe to changes. Returns an unsubscribe function. */
export function onCallChange(handler) {
  const wrapped = () => handler(getActiveCall());
  window.addEventListener(EVT, wrapped);
  window.addEventListener("storage", wrapped);
  return () => {
    window.removeEventListener(EVT, wrapped);
    window.removeEventListener("storage", wrapped);
  };
}
